import type React from "react";
import { useId } from "react";

import { colorsPalettes } from "@similarweb/styles";
import { Dropdown, DropdownButton, SimpleDropdownItem } from "@similarweb/ui-components";

import { StyledBaseDropdownButtonWrap } from "app/pages/sales-intelligence/sub-modules/advanced-search/components/common-styles";

import type { IosIdentifierType } from "../../types";
import { iosIdentifierTypeToAppsIdentifiers } from "../../utils";

import { StyledDropdownContainer } from "./styles";

interface Props {
    value: IosIdentifierType;
    options: readonly IosIdentifierType[];
    onUpdate: (value: IosIdentifierType) => void;
}

export const IosIdentifierDropdown: React.FC<Props> = ({ value, onUpdate, options }) => {
    const dropdownId = useId();

    const renderItems = () =>
        options.map((identifierType) => (
            <SimpleDropdownItem
                key={identifierType}
                id={identifierType}
                selected={value === identifierType}
            >
                {iosIdentifierTypeToAppsIdentifiers[identifierType]}
            </SimpleDropdownItem>
        ));

    const handleSelect = (item: { id: IosIdentifierType }) => {
        onUpdate(item.id);
    };

    return (
        <StyledDropdownContainer id={dropdownId}>
            <Dropdown
                appendTo={`#${CSS.escape(dropdownId)}`}
                onClick={handleSelect}
                width={116}
                dropdownPopupPlacement="ontop-left"
            >
                {[
                    <StyledBaseDropdownButtonWrap
                        key="dropdown-button"
                        buttonTextColor={colorsPalettes.carbon[400]}
                    >
                        <DropdownButton>{iosIdentifierTypeToAppsIdentifiers[value]}</DropdownButton>
                    </StyledBaseDropdownButtonWrap>,
                ].concat(renderItems())}
            </Dropdown>
        </StyledDropdownContainer>
    );
};
